<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Авторизация</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Имя пользователя"
                    name="username"
                    prepend-icon="person"
                    required
                    type="text"
                    v-model="username"
                    @keypress.enter="login"
                  />

                  <v-text-field
                    v-model="password"
                    id="password"
                    label="Пароль"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    required
                    @keypress.enter="login"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="login" :loading="loading" :disabled="loading"
                  >Войти
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-snackbar
      v-model="snack"
      :top="true"
      timeout.number="90000"
      multi-line
      id="glob-snackbar"
      class="snackbar"
    >
      {{ snackbarMessage }}
      <v-btn text color="pink" @click="snack = false">Закрыть</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { AUTH_REQUEST } from '@/store/actions/auth'

export default {
  name: 'Login',
  data: () => ({
    snack: false,
    snackbarMessage: '',
    valid: false,
    loading: false,
    username: '',
    password: '',
    notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
    select: null,
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    login() {
      if (!this.username || !this.password) {
        this.snackbarMessage = 'Заполните все поля'

        this.snack = true
        return
      }
      this.loading = true
      this.$store
        .dispatch(AUTH_REQUEST, { username: this.username, password: this.password })
        .then((res) => {
          if (this.$route.query.next) {
            this.$router.push(this.$route.query.next)
          } else {
            this.$router.push('/')
          }
        })
        .catch((err) => {
          this.snackbarMessage = err.message
          this.snack = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
}
</script>
